import { render, staticRenderFns } from "./FavoriteSelector.vue?vue&type=template&id=729408b9&scoped=true"
import script from "./FavoriteSelector.vue?vue&type=script&lang=js"
export * from "./FavoriteSelector.vue?vue&type=script&lang=js"
import style0 from "./FavoriteSelector.vue?vue&type=style&index=0&id=729408b9&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "729408b9",
  null
  
)

export default component.exports